import { PaymentFormData } from "@/Components/UI/Onboarding/Client/PaymentForm/PaymentForm";
import { ExperimentFaqItemType } from "@/Pages/Client/PaymentPage/Partials/PaymentFAQItem";
import { PiFlask } from "react-icons/pi";

const studies = [
    {
        authors: "De Haan & Nilsson",
        publication: "Academy of Management Learning & Education",
        year: "2023",
        url: "https://research.vu.nl/en/publications/what-can-we-know-about-the-effectiveness-of-coaching-a-meta-analy/",
    },
    {
        authors: "Theeboom et al.",
        publication: "The Journal of Positive Psychology",
        year: "2014",
        url: "https://www.tandfonline.com/doi/abs/10.1080/17439760.2013.837499",
    },
    {
        authors: "Grant et al.",
        publication: "The Journal of Positive Psychology",
        year: "2009",
        url: "https://www.tandfonline.com/doi/abs/10.1080/17439760902992456",
    },
];

export function getCoachingEvidenceFaqItem(
    paymentFormData: PaymentFormData,
): ExperimentFaqItemType | null {
    if (paymentFormData.coachingEvidenceFaqVariant !== "treatment") {
        return null;
    }

    return {
        icon: <PiFlask />,
        title: "Is there real evidence that coaching works?",
        description: (
            <div className="flex flex-col gap-3">
                <p>
                    Independent research says yes. Across 37 randomized studies
                    of more than 2,500 people, 4 to 8 sessions of coaching
                    produced significant gains in goal attainment, resilience,
                    and well-being.
                </p>
                <p className="text-sm italic text-brand-gray">
                    (
                    {studies.map((study, index) => (
                        <span key={study.url}>
                            <a
                                href={study.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-brand-gray underline"
                            >
                                {study.authors}
                            </a>
                            , {study.publication} ({study.year})
                            {index < studies.length - 1 ? ". " : ""}
                        </span>
                    ))}
                    ).
                </p>
            </div>
        ),
    };
}
